import {
  createLocalizationKey,
  IModal,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
  StepperCompletionMessageModal,
  ZendraLocalizationServices,
} from '@zendra/shared';
import { StepSelectContract } from './step-select-contract/step-select-contract';
import { StepAssociateProperty } from './step-associate-property/step-associate-property';
import { StepAssociateStandCycleRotation } from './step-associate-stand-cycle-rotation/step-associate-stand-cycle-rotation';
import { StepSetPropertyType } from './step-set-property-type/step-set-property-type';

export const COMPLETE_STEPPER_MESSAGE: IModal = {
  asideConfig: { show: false },
  confirmLabel: createLocalizationKey('Confirm', ZendraLocalizationServices.LanguageService),
  dismissLabel: createLocalizationKey('Close', ZendraLocalizationServices.LanguageService),
  backdrop: 'static',
  size: 'md',
  title: createLocalizationKey(
    'ContractAssignmentByStand.StepSetPropertyType.CompletedConfirmationMessage',
    ZendraLocalizationServices.Geographic,
  ),
  component: StepperCompletionMessageModal,
  inputs: {
    message: createLocalizationKey(
      'ContractAssignmentByStand.StepSetPropertyType.CompletedMessage',
      ZendraLocalizationServices.Geographic,
    ),
  },
};

export const STEP_COMPONENTS_CONFIG = [
  { id: 1, titleKey: 'StepSelectContract.Title', component: StepSelectContract },
  { id: 2, titleKey: 'StepAssociateProperty.Title', component: StepAssociateProperty },
  {
    id: 3,
    titleKey: 'StepAssociateStandCycleRotation.Title',
    component: StepAssociateStandCycleRotation,
  },
  { id: 4, titleKey: 'StepSetPropertyType.Title', component: StepSetPropertyType },
] as const;

export const DEFAULT_PROPERTIES_MAX_RESULT_COUNT = 200;

export const CONTRACTASSIGNMENTBYSTAND_CONFIG = {
  entityName: 'StandCycleRotation',
  localizationKey: 'Geographic::ContractAssignmentByStand',
  permission: 'PlanningGeography.StandCycleRotations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory:
    MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
};
